export default "__VITE_ASSET__57ef6166__"